import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) => ({
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#F7F9FA'
        // marginBottom: '6%'
    },
    gridClass: {
        backgroundColor: 'white',
        border: '0px !important',
        margin: '10px 0px !important',
        height: '100%',
        width: '100%',
        fontSize: '13px !important'
    },
    mainBody: {
        marginBottom: '10%'
    },
    tabLabel: {
        fontSize: `${theme.palette.textSizeLarge} !important`,
        fontWeight: '600 !important'
    },
    leftContainer: {
        width: '100%',
        height: '616px',
        backgroundColor: 'white',
        padding: '20px',
        // margin: '10px',
        borderRadius: '12px',
        boxShadow: 'rgb(149 157 165 / 20%) 0px 6px 6px',
        '@media (max-width: 600px)': {
            marginTop: '20px'
        }
    },
    backSet: {
        backgroundColor: '#F7F9FA',
        display: 'flex'
    },
    frstHead: {
        fontSize: '30px',
        fontWeight: 'bold',
        color: '#272727'
    },
    timeHead: {
        color: '#ACAEC2',
        fontSize: theme.palette.textSizeLarge,
        marginBottom: '22px'
    },
    leftCard: {
        backgroundColor: '#FF1616 !important',
        // width: '337px',
        height: '59px',
        fontWeight: 'bold',
        marginTop: '30px',
        marginBottom: '30px',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        alignItems: 'center',
        borderRadius: '11px !important'
    },
    leftCardCheck: {
        backgroundColor: '#2C8F29 !important',
        // width: '337px',
        // height: '59px',
        fontWeight: 'bold',
        marginTop: '30px',
        marginBottom: '30px',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        alignItems: 'center',
        borderRadius: '11px !important'
    },
    performText: {
        marginLeft: '10px',
        fontWeight: 'bold',
        fontSize: theme.palette.textSizeLarge,
        paddingBottom: '15px'
    },
    cardMsg: {
        color: 'white',
        display: 'flex',
        marginTop: '17px',
        marginLeft: '30px'
    },
    warnIcon: {
        // marginTop: '5px'
    },
    linColor: {
        borderTop: '1px solid #D5D5D5',
        borderBottom: '1px solid #D5D5D5'
    },
    serviceAlign: {
        display: 'flex',
        marginTop: '30px',
        marginLeft: '10px'
    },
    statusAlign: {
        marginLeft: '60%'
    },
    serviceheadAlign: {
        display: 'flex',
        marginTop: '24px',
        marginLeft: '10px'
    },
    chipStyle: {
        height: '24px !important',
        color: '#2C8F29 !important',
        width: '120px !important',
        backgroundColor: '#CBF4D3 !important',
        borderRadius: '4px !important',
        marginLeft: 'auto',
        fontSize: '13px !important'
        // fontWeight: 'bold !important'
    },
    chipStyleTwo: {
        height: '24px !important',
        color: '#FFFFFF !important',
        width: '164px !important',
        backgroundColor: '#FF8D00 !important',
        borderRadius: '5px !important',
        marginLeft: 'auto',
        fontSize: '13px !important'
    },
    servicename: {
        fontSize: theme.palette.textSizeExtraLarge,
        fontWeight: '600',
        textTransform: 'capitalize'
    },
    rightContainer: {
        width: '100%'
    },
    dataShow: {
        width: '100%',
        backgroundColor: 'white',
        height: '550px',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #D5D5D5'
    },
    currentShow: {
        backgroundColor: 'white',
        height: '592px',
        borderRadius: '12px',
        paddingTop: '25vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto'
    },
    noIncidentsPic: {
        marginLeft: '10px'
    },
    pastShow: {
        width: '780px',
        backgroundColor: 'white',
        height: '592px',
        borderRadius: '12px',
        padding: '190px 275px',
        display: 'flex',
        flexDirection: 'column'
    },
    rightBottom: {
        display: 'flex'
    },
    bottomCont: {
        width: '100%',
        height: '346px',
        backgroundColor: 'white',
        margin: '20px',
        borderRadius: '12px',
        // marginBottom: '20px',
        padding: '20px'
    },
    insideCont: {
        display: 'flex',
        fontSize: '14px',
        fontWeight: '550'
    },
    subCont: {
        marginLeft: '65%',
        fontSize: '14px',
        fontWeight: '550'
    },
    subContTwo: {
        marginLeft: '55%',
        fontSize: '16px',
        fontWeight: '550'
    },
    subContThree2: {
        marginLeft: '15%',
        fontSize: '16px',
        fontWeight: '550'
    },
    subContThree3: {
        marginLeft: '10%',
        fontSize: '16px',
        fontWeight: '550'
    },
    subContThree1: {
        marginLeft: '28%',
        fontSize: '16px',
        fontWeight: '550'
    },
    contOne: {
        fontWeight: '550'
    },
    valueCont: {
        display: 'flex',
        margin: '18px 0px',
        fontSize: '16px'
    },
    subValueCont: {
        marginLeft: 'auto',
        fontSize: '16px'
    },
    fontAdjust: {
        fontWeight: 'bold'
    },
    subThirdFlex: {
        display: 'flex',
        padding: '15px 10px',
        marginTop: '10px',
        borderRadius: '8px',
        justifyContent: 'space-between',
        width: '100%'
    },
    headFont: {
        fontWeight: '550',
        fontSize: '16px'
    },
    thirdMin: {
        fontWeight: '550',
        fontSize: '16px'
    },
    // thirdMin: {
    //     textOverflow: 'ellipsis'
    // },
    // HEADER
    logotype: {
        // [theme.breakpoints.down('xs')]: {
        //     display: 'none'
        // },
        marginTop: '0.5%'
    },
    appBar: {
        width: '100vw',
        height: '75px',
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        boxShadow: 'none !important'
        // transition: theme.transitions.create(['margin'], {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen
        // })
    },
    toolbar: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(2),
        minHeight: '75px'
    },
    hide: {
        display: 'none'
    },
    grow: {
        flexGrow: 1
    },
    search: {
        position: 'relative',
        borderRadius: 25,
        paddingLeft: theme.spacing(2.5),
        width: 36,
        backgroundColor: alpha(theme.palette.common.black, 0),
        transition: theme.transitions.create(['background-color', 'width']),
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: alpha(theme.palette.common.black, 0.08)
        }
    },
    searchFocused: {
        backgroundColor: alpha(theme.palette.common.black, 0.08),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 250
        }
    },
    searchIcon: {
        width: 36,
        right: 0,
        height: '100%',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create('right'),
        '&:hover': {
            cursor: 'pointer'
        }
    },
    searchIconOpened: {
        right: theme.spacing(1.25)
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        height: 36,
        padding: 0,
        paddingRight: 36 + theme.spacing(1.25),
        width: '100%'
    },
    messageContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    headerMenu: {
        marginTop: theme.spacing(7)
    },
    headerMenuList: {
        display: 'flex',
        flexDirection: 'column'
    },
    headerMenuItem: {
        '&:hover, &:focus': {
            backgroundColor: theme.palette.background.light
            // color: "white",
        }
    },
    headerMenuNoti: {
        background:
            'transparent linear-gradient(259deg, #FFB300 0%, #FF8800 100%) 0% 0% no-repeat !important',
        borderRadius: '5px !important',
        color: '#FAFAFA !important',
        marginRight: '17px !important',
        textTransform: 'none',
        justifyContent: 'space-between'
    },
    headerMenuButtonSandwich: {
        marginLeft: 9,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        },
        padding: theme.spacing(0.5)
    },
    headerMenuButtonCollapse: {
        marginRight: theme.spacing(2)
    },
    headerIcon: {
        fontSize: 28,
        color: 'rgba(255, 255, 255, 1.0)'
    },
    headerIconCollapse: {
        color: 'white'
    },
    profileMenu: {
        minWidth: 100
    },
    profileMenuUser: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1)
    },
    profileMenuItem: {
        color: theme.palette.text.hint
    },
    profileMenuIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.text.hint,
        '&:hover': {
            color: theme.palette.primary.main
        }
    },
    profileMenuLink: {
        fontSize: 16,
        color: '#000 !important',
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    messageNotification: {
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.background.light
        }
    },
    messageNotificationSide: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: theme.spacing(2)
    },
    messageNotificationBodySide: {
        alignItems: 'flex-start',
        marginRight: 0
    },
    sendMessageButton: {
        margin: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textTransform: 'none'
    },
    sendButtonIcon: {
        marginLeft: theme.spacing(2)
    },
    purchaseBtn: {
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
        marginRight: theme.spacing(3)
    },
    fontAwesomeIcon: {
        fontSize: '18px'
    },
    buttonText: {
        marginLeft: '10px'
    },
    fontAwesomeUserIcon: {
        fontSize: '30px'
    },
    unreadBadge: {
        // boxShadow: '0px 0px 10px #FFC260'
    },
    profileLogo: {
        borderRadius: '50%'
    },
    clientName: {
        color: '#333A4D',
        fontSize: '14px',
        marginLeft: '9px'
    },
    tableContentWrapper: {
        display: 'flex',
        // minHeight: '90vh',
        flexDirection: 'column',
        // marginBottom: '80px',
        margin: '0px 8px 80px 8px',
        '& .MuiDataGrid-main .MuiDataGrid-columnsContainer': {
            overflow: 'hidden !important',
            border: '1px solid #E9EBF0 !important',
            borderRadius: '8px',
            minHeight: '50px !important',
            maxHeight: '50px !important'
        }
    },
    statusComp: {
        fontSize: '12px',
        width: 'auto',
        height: '21px',
        fontWeight: 'bold',
        borderRadius: '4px',
        padding: '2px 12px'
    },
    serviceComp: {
        backgroundColor: '#F4F5F7',
        color: '#3D4045',
        width: 'auto',
        height: '21px',
        borderRadius: '4px',
        margin: '2px 2px',
        padding: '1px 2px',
        fontSize: '12px',
        fontWeight: '600'
    },
    tableSearchIcon: {
        width: '13px !important',
        height: '13px !important',
        marginBottom: '2px'
    },
    searchTextField: {
        marginTop: '12px'
    },
    resize: {
        fontSize: theme.palette.textSizeMedium
    },
    customPagination: {
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
            {
                display: 'none'
            },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
            {
                margin: '0px 5px'
            }
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '5px'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },
    loaderIncident: {
        position: 'relative',
        top: '46%',
        left: '50%'
    }
}));
